import { AuthFailedException } from './auth-failed-exception';

/**
 * Exception type covering authentication errors.
 **/
export class AuthenticationFailedException extends AuthFailedException {
  name = 'AuthenticationFailedException';

  constructor(message) {
    super(message);
    // Set the prototype explicitly.
    Object.setPrototypeOf(this, AuthenticationFailedException.prototype);
  }
}
